import request from '@/utils/request'

export function getGuidePackages() {
  return request({
    url: '/api/guide/packages/list',
    method: 'post'
  })
}

export function getGuidePackagesByLevel(level) {
  return request({
    url: `/api/guide/packages/level/${level}`,
    method: 'post'
  })
}

export function applyNewGuide(data) {
  return request({
    url: '/api/guide/apply/new',
    method: 'post',
    data
  })
}

export function applyUpgradeGuide(data) {
  return request({
    url: '/api/guide/apply/upgrade',
    method: 'post',
    data
  })
}

export function getMyGuide(userId) {
  return request({
    url: '/api/guide/my',
    method: 'post',
    data: { userId }
  })
}

export function getMyApplications(userId) {
  return request({
    url: '/api/guide/applications/my',
    method: 'post',
    data: { userId }
  })
}

export function getPendingApplications() {
  return request({
    url: '/api/admin/guide/applications/pending',
    method: 'post'
  })
}

export function approveApplication(id, adminId) {
  return request({
    url: `/api/admin/guide/applications/${id}/approve`,
    method: 'post',
    data: { adminId }
  })
}

export function rejectApplication(id, adminId, reason) {
  return request({
    url: `/api/admin/guide/applications/${id}/reject`,
    method: 'post',
    data: { adminId, reason }
  })
}

export function getAllGuides() {
  return request({
    url: '/api/admin/guide/guides',
    method: 'post'
  })
}

export function getGuidesByLevel(level) {
  return request({
    url: `/api/admin/guide/guides/level/${level}`,
    method: 'post'
  })
}

export function getAllPackages() {
  return request({
    url: '/api/admin/guide/packages',
    method: 'post'
  })
}

export function createPackage(data) {
  return request({
    url: '/api/admin/guide/packages',
    method: 'post',
    data
  })
}

export function updatePackage(id, data) {
  return request({
    url: `/api/admin/guide/packages/${id}/update`,
    method: 'post',
    data
  })
}

export function updatePackageStatus(id, status) {
  return request({
    url: `/api/admin/guide/packages/${id}/status`,
    method: 'post',
    params: { status }
  })
}

export function getMyPackages() {
  return request({
    url: '/api/guide/my/packages',
    method: 'post'
  })
}

export function getPackageTemplates() {
  return request({
    url: '/api/guide/package/templates',
    method: 'post'
  })
}

export function getBoundFamilies(params) {
  return request({
    url: '/api/guide/families/bound-families',
    method: 'post',
    data: params
  })
}

export function getTeamMembers(params) {
  return request({
    url: '/api/guide/team/members',
    method: 'post',
    data: params
  })
}

export function getTeamStats(params) {
  return request({
    url: '/api/guide/team/stats',
    method: 'post',
    data: params
  })
}

export function getGuideOrders(params) {
  return request({
    url: '/api/guide/orders/list',
    method: 'post',
    data: params
  })
}

export function getOrderStats(params) {
  return request({
    url: '/api/guide/orders/stats',
    method: 'post',
    data: params
  })
}

export function getGuideMessages(params) {
  return request({
    url: '/api/guide/messages/list',
    method: 'post',
    data: params
  })
}

export function sendMessage(data) {
  return request({
    url: '/api/guide/messages/send',
    method: 'post',
    data
  })
}

export function replyMessage(messageId, replyContent) {
  return request({
    url: `/api/guide/messages/${messageId}/reply`,
    method: 'post',
    data: { replyContent }
  })
}

export function getGuideDashboardStats() {
  return request({
    url: '/api/guide/families/dashboard-stats',
    method: 'post'
  })
}

export function getMyInviteCode() {
  return request({
    url: '/api/guide/team/invite-code',
    method: 'post'
  })
}